export const isUrlValid = (url: string): boolean => {
  const URLRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9_-]+\.)+[a-zA-Z0-9]{2,}(\/\S*)?$/;

  return URLRegex.test(url);
};

export const forceHttpsProtocol = (url: string): string => {
  if (url.startsWith('https://')) {
    return url;
  }

  if (url.startsWith('http://')) {
    return url.replace(/^http/, 'https');
  }

  return `https://${url}`;
};
